import '@babel/polyfill'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Cookies Message
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//////////////////////////////////////////////////////////////// Collapse (Accordion)
import {
    CollapsePlugin
} from 'bootstrap-vue'
Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Fixed element on scroll
import Affix from 'vue-affix'
Vue.use(Affix)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -100,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Bootstrap Tabs
// import {
//     TabsPlugin
// } from 'bootstrap-vue'
// Vue.use(TabsPlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Marquee Text
import MarqueeText from 'vue-marquee-text-component'
Vue.component('MarqueeText', MarqueeText)

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('BgImage', BgImage)

//////////////////////////////////////////////////////////////// Background Video
import BgVideo from './components/bg-video/index.vue'
Vue.component('BgVideo', BgVideo)

//////////////////////////////////////////////////////////////// Count On View
import CountOnView from './count-on-view.vue'
Vue.component('CountOnView', CountOnView)

//////////////////////////////////////////////////////////////// Select Dropdown
// import vSelect from 'vue-select'
// Vue.component('vSelect', vSelect)
// vSelect.props.components.default = () => ({
//     Deselect: {
//         render: createElement => createElement(''),
//     },
//     OpenIndicator: {
//         render: createElement => createElement('i', {
//             class: {
//                 'icon-arrow-light-down icon-sm': true
//             }
//         }),
//     },
// });

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Scroll Magic
import ScrollMagic from './directives/scroll-magic/index.js';
Vue.directive('ScrollMagic', ScrollMagic)

//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js';
Vue.directive('Gsap', Gsap)

//////////////////////////////////////////////////////////////// Gallery Lightbox
// import FancyBox from './directives/fancy-box'
// Vue.directive('fancy-box', FancyBox)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Bit.dev
import CookiesMsg from './components/cookies-msg/cookies-msg.vue'
import SideMenu from './components/side-menu/side-menu.vue'

//////////////////////////////////////////////////////////////// Local
import CategoriesBanner from './categories-banner'
import HistorySlider from './history-slider'
import ChartCarousel from './chart-carousel'
import GalleryCarousel from './gallery-carousel'
import CenteredCarousel from './centered-carousel'
import FleetList from './fleet-list.js'
import FleetMap from './fleet-map.js'
import ContactForm from './contact-form.js'

import {
    devices,
    isIE
} from './imports/utils'

var app = new Vue({
    el: '#app',
    components: {
        CookiesMsg,
        SideMenu,
        CategoriesBanner,
        HistorySlider,
        ChartCarousel,
        GalleryCarousel,
        CenteredCarousel,
        FleetList,
        FleetMap,
        ContactForm
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            isDevice: devices(),
            isIE: isIE(),
            pageScrolled: false,
            windowWidth: window.innerWidth,
            ratio: window.innerWidth / window.innerHeight,
            // landingVideo: 'https://player.vimeo.com/external/564575170.hd.mp4?s=4344f7e8f95f3ccf5219689362c056009c563209&profile_id=175'
        }
    },
    methods: {
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        // toggleLandingVideo(src) {
        //     if (this.landingVideo === 'https://player.vimeo.com/external/564575170.hd.mp4?s=4344f7e8f95f3ccf5219689362c056009c563209&profile_id=175') {
        //         this.landingVideo = src
        //     } else {
        //         this.landingVideo = 'https://player.vimeo.com/external/564575170.hd.mp4?s=4344f7e8f95f3ccf5219689362c056009c563209&profile_id=175'
        //     }
        // }
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;

        window.addEventListener('scroll', this.onScroll, {
            passive: true
        })

        window.addEventListener("resize", this.onResize, {
            passive: false
        })

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    mounted() {},
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)

        window.removeEventListener("resize", this.onResize)
    }
})